// extracted by mini-css-extract-plugin
module.exports = {"seusDireitosCta":"seus-direitos-cta_seusDireitosCta__Z6sJq","cardVariantAB":"seus-direitos-cta_cardVariantAB__6hv03","cardVariantC":"seus-direitos-cta_cardVariantC__1XTqk"};